
import React from "react";
// react library for routing
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library that concatenates classes
import classnames from "classnames";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
// react library that creates nice scrollbar on windows devices
import PerfectScrollbar from "react-perfect-scrollbar";
// reactstrap components
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Button,
  Input,
  Label,
  Row,
  // ModalFooter,
  Modal,
  ModalHeader,
} from "reactstrap";
import { connect } from 'react-redux';
import { hasValidPermission, history } from "_helpers";
import SweetAlert from "components/react-bootstrap-sweetalert/SweetAlert.jsx";
import { fanModeActions } from '_actions';
import defaultAvatar from "assets/img/default-avatar.png"

class Sidebar extends React.Component {
  constructor(props) {
    const prefersDark = localStorage.getItem("darkMode") === "true";
    const prefersGlitch = localStorage.getItem("glitchMode") === "true";
    super(props);
    this.state = {
      // isFanModeToggled: false, 
      collapseOpen: false,
      alert: null,
      prefersDark: prefersDark,
      prefersGlitch: prefersGlitch,
      glitchCounter: 0,
      ...this.getCollapseStates(props.routes)
    };
    this.toggleFanMode = this.toggleFanMode.bind(this)
    this.hideAlert = this.hideAlert.bind(this);
    this.switchModeAlert = this.switchModeAlert.bind(this);
    this.toggleModal = this.toggleModal.bind(this)
    this.signOut = this.signOut.bind(this);
    this.toggleDarkMode = this.toggleDarkMode.bind(this);
    this.toggleGlitchMode = this.toggleGlitchMode.bind(this);
    this.incrementGlitchMode = this.incrementGlitchMode.bind(this);
  }

  componentDidMount() {
  if (window.innerWidth < 577) {
    document.body.classList.remove("g-sidenav-show");
    document.body.classList.remove("g-sidenav-pinned");
    document.body.classList.add("g-sidenav-hidden");
  }
}
  // verifies if routeName is the one active (in browser input)
  activeRoute = routeName => {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  // makes the sidenav normal on hover (actually when mouse enters on it)
  onMouseEnterSidenav = () => {
    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.add("g-sidenav-show");
    }
  };
  // makes the sidenav mini on hover (actually when mouse leaves from it)
  onMouseLeaveSidenav = () => {
    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-show");
    }
  };
  // toggles collapse between opened and closed (true/false)
  toggleCollapse = () => {
    this.setState({
      collapseOpen: !this.state.collapseOpen
    });
  };
  // closes the collapse
  closeCollapse = () => {
    this.setState({
      collapseOpen: false
    });
  };

  toggleDarkMode() {
    // {prefersDark ? "spc-white" : "dark"}
    // {prefersDark ? "white" : "dark"}
    // {prefersDark ? "spc-white" : "default"}
    const prefersDark = localStorage.getItem("darkMode") === "true";
    const prefersGlitch = localStorage.getItem("glitchMode") === "true";
    if (prefersDark) {
      localStorage.setItem("userSetDarkMode", false)
      localStorage.setItem("darkMode", false)
      localStorage.setItem("glitchMode", false)
      document.documentElement.classList.remove("dark-mode");
      document.documentElement.classList.remove("glitch-mode");
      this.setState({
        prefersDark: false,
        prefersGlitch: false,
        glitchCounter: 0
      })
    } else {
      localStorage.setItem("userSetDarkMode", true)
      localStorage.setItem("darkMode", true)
      document.documentElement.classList.add("dark-mode");
      this.setState({
        prefersDark: true
      })
    }
  }

  toggleGlitchMode() {
    // {prefersDark ? "spc-white" : "dark"}
    // {prefersDark ? "white" : "dark"}
    // {prefersDark ? "spc-white" : "default"}
    const prefersDark = localStorage.getItem("darkMode") === "true";
    const prefersGlitch = localStorage.getItem("glitchMode") === "true";
    if (prefersGlitch) {
      localStorage.setItem("glitchMode", false)
      document.documentElement.classList.remove("glitch-mode");
      this.setState({
        prefersGlitch: false,
        glitchCounter: 0
      })
    } else {
      localStorage.setItem("userSetDarkMode", true)
      localStorage.setItem("darkMode", true)
      localStorage.setItem("glitchMode", true)
      document.documentElement.classList.add("dark-mode");
      document.documentElement.classList.add("glitch-mode");
      this.setState({
        prefersDark: true,
        prefersGlitch: true,
      })
    }
  }

  incrementGlitchMode() {
    this.setState(prevState => ({
      glitchCounter: prevState.glitchCounter + 1
    }));
  }

  // this creates the intial state of this component based on the collapse routes
  // that it gets through this.props.routes
  getCollapseStates = routes => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: this.getCollapseInitialState(prop.views),
          ...this.getCollapseStates(prop.views),
          ...initialState
        };
      }
      return null;
    });
    return initialState;
  };

  toggleModal = state => {
    this.setState({
      [state]: !this.state[state]
    });
  };

  signOut() {
    console.log("logging out")
    this.setState({ modalNotice: false, })
    history.push('/auth/logout')
  }
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.jsx - route /dash/regular-forms
  getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.href.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  }
  // this is used on mobile devices, when a user navigates
  // the sidebar will autoclose
  closeSidenav = () => {
    if (window.innerWidth < 1200) {
      this.props.toggleSidenav();
    }
  };
  // this function creates the links and collapses that appear in the sidebar (left menu)
  createLinks = (routes, isCollapsedLink) => {
    const { loggedIn, info } = this.props;
    const { prefersDark, prefersGlitch } = this.state
    const user = JSON.parse(localStorage.getItem('user'));
    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (!this.showItem(loggedIn, user, info, prop.showFor, prop.name)) return null;
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !this.state[prop.state];
        return (
          <NavItem key={key}>
            <NavLink
              href="#pablo"
              data-toggle="collapse"
              aria-expanded={this.state[prop.state]}
              className={classnames({
                active: this.getCollapseInitialState(prop.views)
              })}
              onClick={e => {
                e.preventDefault();
                this.setState(st);
              }}
            >
              {prop.icon ? <i className={(prop.icon + (prefersGlitch ? " glitch-text" : ""))} /> : null}
              <span className={(("nav-link-text pl-1 ") + (prefersGlitch ? " glitch-text-off" : ""))}>{prop.name}</span>
            </NavLink>
            <Collapse isOpen={this.state[prop.state]}>
              <Nav className="nav-sm flex-column">
                {this.createLinks(prop.views, true)}
              </Nav>
            </Collapse>
          </NavItem>
        );
      }
      return (
        <NavItem
          className={this.activeRoute(prop.layout + prop.path)}
          key={key}
        >
          <NavLink
            to={prop.layout + prop.path}
            activeClassName=""
            onClick={this.closeSidenav}
            tag={NavLinkRRD}
          >
            {prop.icon !== undefined ? (
              <>
                <i className={(prop.icon + (prefersGlitch ? " glitch-text" : ""))} />
                <span className={(("nav-link-text pl-1 ") + (prefersGlitch ? "glitch-text-off" : ""))} style={{ fontWeight: "600" }}>{prop.name}</span>
              </>
            ) : (
              <span style={{ fontWeight: "600" }} className={"nav-link-text pl-1 " + (isCollapsedLink ? "collapsedLink " : "") + (prefersGlitch ? " glitch-text-off" : "")}>{prop.name}</span>
            )}
          </NavLink>
        </NavItem>
      );
    });
  };

  // Show sidebar item
  showItem(loggedIn, user, info, showFor, name) {
    const { fanMode } = this.props
    // console.log("showItem", loggedIn, user, showFor, name)
    if (!loggedIn) {
      return showFor.indexOf('LoggedOut') > -1 ? true : false;
    }
    if (!user) {
      return false
    }
    if ((user.is_business && !fanMode && showFor.indexOf('Business') > -1) ||
      (user.is_specialist && !fanMode && showFor.indexOf('Specialist') > -1) ||
      (user.is_agency && showFor.indexOf('Agency') > -1) ||
      ((user.is_user || fanMode) && showFor.indexOf('User') > -1) ||
      (info && info.hasOwnProperty('affiliate_code') && hasValidPermission() && showFor.indexOf('Affiliate') > -1)) {
      return true
    }
    return false;
  }

  switchModeAlert() {
    const { fanMode } = this.props
    const user = JSON.parse(localStorage.getItem('user'));

    const userIsSpecialist = user && user.is_specialist
    const userIsBusiness = user && user.is_business

    const switchingToFanMode = fanMode === false
    const switchingToCreatorMode = !switchingToFanMode && userIsSpecialist
    const switchingToBusinessMode = !switchingToFanMode && userIsBusiness

    const switchingTo = switchingToFanMode ? "Fan" : switchingToCreatorMode ? "Creator" : switchingToBusinessMode ? "Business" : "Agency"
    const switchingToRoute = switchingToFanMode ? ('/dash/user-dashboard') : switchingToCreatorMode ? ('/dash/celeb-dashboard') : switchingToBusinessMode ? ('/dash/business-dashboard') : ('/dash/agency-dashboard')
    this.setState({
      alert: (
        <SweetAlert
          title={`Switch to ${switchingTo}`}
          onConfirm={() => this.toggleFanMode(switchingToRoute)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="primary"
          confirmBtnText="Switch"
          showCancel
          type="info"
        >
          <p className="text-center text-darkerGray"
            style={{ fontSize: "77%" }}>
            <span>
              <span className="h4">{`You are about to switch to ${switchingTo} mode. If you have any unsaved changes on the current page, they may be lost.`}
              </span>
              {/* <br/>Please click the link in the email to continue the account recovery process. */}
            </span>
          </p>
        </SweetAlert>
      )
    });
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  toggleFanMode(switchingToRoute) {
    const { fanMode } = this.props
    history.push(switchingToRoute)


    if (fanMode) {
      this.props.dispatch(fanModeActions.turnFanModeOff())
    } else {
      this.props.dispatch(fanModeActions.turnFanModeOn())
    }

    this.setState({
      // isFanModeToggled: !this.state.isFanModeToggled,
      alert: null,
    })

    // const { isFanModeToggled} = this.state 
    // const user = JSON.parse(localStorage.getItem('user')); 

    // const userIsSpecialist = user && user.is_specialist
    // // const userIsBusiness = user && user.is_business

    // const switchingToFanMode = isFanModeToggled === false 
    // const switchingToCreatorMode = !switchingToFanMode && userIsSpecialist
    // // const switchingToBusinessMode = !switchingToFanMode && userIsBusiness

    // const switchingTo = switchingToFanMode ? "Fan mode" : switchingToCreatorMode ? "Creator mode" : "Business mode"
    // const switchingToRoute = switchingToFanMode ? ('/dash/user-dashboard') : switchingToCreatorMode ? ('/dash/celeb-dashboard') : ('/dash/business-dashboard')
    // if (window.confirm(`You are about to switch to ${switchingTo}. If you have any unsaved changes on the current page, they may be lost.`)) {
    //   history.push(switchingToRoute)
    //   this.setState({
    //     isFanModeToggled: !this.state.isFanModeToggled
    //   })
    // } else {
    //   // if reject, skip.
    //   // reject()
    // }



    console.log("switch", this.props.fanMode)

  }
  render() {
    const { prefersDark, prefersGlitch, glitchCounter } = this.state
    const { routes, logo, info } = this.props;
    const { fanMode } = this.props
    const user = JSON.parse(localStorage.getItem('user'));
    const userIsAgencyAsClient = user && user.agency_as_client;
    const userIsSpecialist = user && user.is_specialist;
    const userIsBusiness = user && user.is_business;
    const userIsUser = user && user.is_user
    const userIsAgency = user && user.is_agency
    const loggedIn = user && user.hasOwnProperty('email');

    // const userIsUser = user && user.is_user 

    let navbarBrandProps;
    if (logo && logo.innerLink) {
      navbarBrandProps = {
        // to: logo.innerLink,
        // tag: Link
      };
    } else if (logo && logo.outterLink) {
      navbarBrandProps = {
        // href: logo.outterLink,
        // target: "_blank"
      };
    }
    const scrollBarInner = (
      <div className="scrollbar-inner">
        <div className="sidenav-header d-flex align-items-center">
          {logo ? (
            <NavbarBrand {...navbarBrandProps}>
              {prefersGlitch ? (
                <h1 className="my-0 display-4 livenyte-title livenyte-title-glitch glitch-text cursor-pointer" onClick={this.props.toggleSidenav} style={{ fontSize: "1.71rem" }}>LiveNyte</h1>
              ) : (
                <img
                  alt={logo.imgAlt}
                  className="navbar-brand-img cursor-pointer"
                  onClick={this.props.toggleSidenav}
                  src={prefersGlitch ? logo.imgSrcGlitched : prefersDark ? logo.imgSrcDark : logo.imgSrc}
                />
              )}

            </NavbarBrand>
          ) : null}
          <div className="ml-auto">
            <div
              className={classnames("sidenav-toggler d-none d-xl-block", {
                active: this.props.sidenavOpen
              })}
              onClick={this.props.toggleSidenav}
            >
              <div className="sidenav-toggler-inner">
                <i className={(("sidenav-toggler-line") + (prefersGlitch ? " glitch-bg" : ""))}>
                  <span className="toggler-line-content"></span>
                </i>
                <i className={(("sidenav-toggler-line") + (prefersGlitch ? " glitch-bg" : ""))}>
                </i>
                <i className={(("sidenav-toggler-line") + (prefersGlitch ? " glitch-bg" : ""))}>
                  <span className="toggler-line-content"></span>
                </i>
              </div>
            </div>
          </div>
        </div>
        <div className="navbar-inner">
          <Collapse navbar isOpen={true}>
            <Nav navbar>{this.createLinks(routes, false)}</Nav>
            {(userIsSpecialist || userIsBusiness || userIsAgency) &&
              <div>
                <hr className="my-3" />
                <h6 style={{ letterSpacing: "2px", fontSize: "0.715rem" }} className={(("navbar-heading p-0 surtitle h6 mb-1 ") + (prefersGlitch ? "livenyte-title-glitch-off" : ""))}>
                  {userIsAgencyAsClient && !fanMode ? "Client Mode" :
                    userIsSpecialist && !fanMode ? "Creator Mode" :
                      userIsBusiness && !fanMode ? "Business Mode" :
                        userIsAgency && !userIsAgencyAsClient && !fanMode ? "Agency Mode" :
                          "Fan Mode"
                  }

                </h6>
                {!userIsAgencyAsClient && !userIsAgency &&
                  <Button className={
                    (prefersGlitch) && fanMode ? (("navbar-button btn-primary mt-2 mb-1 pt-1 ") + (userIsSpecialist ? "btn-outline-primary" : userIsBusiness ? "btn-outline-purple" : "btn-outline-gold")) :
                      prefersGlitch && !fanMode ? "navbar-button btn-outline-spc-white mt-2 mb-1 pt-1 " :
                        prefersDark && fanMode ? (("navbar-button btn-primary mt-2 mb-1 pt-1  ") + (userIsSpecialist ? "btn-outline-primary" : userIsBusiness ? "btn-outline-purple" : "btn-outline-gold")) :
                          prefersDark && !fanMode ? "navbar-button btn-outline-spc-white mt-2 mb-1 pt-1 " :
                            !prefersDark && fanMode ? (("navbar-button mt-2 mb-1 pt-1 ") + (userIsSpecialist ? " btn-primary  bg-gradient-livenyte" : userIsBusiness ? " btn-purple bg-gradient-purple" : "btn-darkGold bg-darkGold")) :
                              "navbar-button btn-outline-primary mt-2 mb-1 pt-1"}
                    // className={((fanMode ? "navbar-button btn-primary bg-gradient-livenyte mt-2 mb-1 pt-1 " : (("navbar-button btn-outline-primary mt-2 mb-1 pt-1 ")  + (prefersDark ? "" : "")) )) } 
                    color="primary" size="sm" onClick={this.switchModeAlert}>
                    {
                      userIsSpecialist && fanMode ? "Switch to Creator" :
                        userIsBusiness && fanMode ? "Switch to Business" :
                          userIsAgency && fanMode ? "Switch to Agency" :
                            // userIsAgency && !userIsAgencyAsClient && fanMode ? "Switch to Agency" :
                            "Switch to Fan"
                    }
                  </Button>
                }
                {userIsAgencyAsClient &&
                  <Button className={"bg-darkMode mt-2 mb-1 pt-1"} color={prefersGlitch ? "white livenyte-title-glitch-off" : prefersDark ? "white" : "darkMode "} size="sm" onClick={() => this.toggleModal("logOutModal")}>
                    {"Change Client"}
                  </Button>
                }
              </div>
            }

            <div>
              <hr className="my-3" />
              <Row className="mx-0">
                <h6 onClick={() => this.incrementGlitchMode()} style={{ letterSpacing: "2px", fontSize: "0.715rem" }} className={(("navbar-heading p-0 surtitle h6 mt-1 " + (prefersGlitch ? "livenyte-title-glitch-off" : "")))}>
                  {"DARK MODE"}
                </h6>
                <Label className={(("custom-toggle-bids custom-toggle-white ml-3 pt-0 navbar-button ") + (prefersGlitch ? "livenyte-title-glitch-off" : ""))} >
                  <Input type="checkbox"
                    name="toggleDarkMode"
                    value={prefersDark}
                    checked={prefersDark}
                    onChange={() => this.toggleDarkMode()}
                  />
                  <span
                    className="custom-toggle-slider rounded-circle"
                    data-label-off="Off"
                    data-label-on="On"
                  />
                </Label>
              </Row>
              {(prefersGlitch || glitchCounter > 7) &&
                <Row className="mx-0 mt-4 glitch-text-hoverOnlySelector glitch-text-hoverOnly">
                  <h6 style={{ letterSpacing: "2px", fontSize: "0.715rem" }} className={(("navbar-heading p-0 surtitle h6 mt-1 livenyte-title-glitch glitch-text-hoverOnlyTarget"))}>
                    {"Nyte MODE"}
                  </h6>
                  <Label className="custom-toggle-bids custom-toggle-white ml-3 pt-0 navbar-button glitch-text glitch-text-hoverOnlyTarget" >
                    <Input type="checkbox"
                      name="toggleGlitchMode"
                      value={prefersGlitch}
                      checked={prefersGlitch}
                      onChange={() => this.toggleGlitchMode()}
                    />
                    <span
                      className="custom-toggle-slider rounded-circle glitch-text-hoverOnlyTarget"
                      data-label-off="Off"
                      data-label-on="On"
                    />
                  </Label>
                </Row>
              }
            </div>


            {/* <Nav className="mb-md-3" navbar>
              <NavItem>
                <NavLink
                  target="_blank"
                >
                  <i className="ni ni-spaceship" />
                  <span className="nav-link-text">Getting started</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  target="_blank"
                >
                  <i className="ni ni-palette" />
                  <span className="nav-link-text">Foundation</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  target="_blank"
                >
                  <i className="ni ni-ui-04" />
                  <span className="nav-link-text">Components</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  target="_blank"
                >
                  <i className="ni ni-chart-pie-35" />
                  <span className="nav-link-text">Plugins</span>
                </NavLink>
              </NavItem>
            </Nav> */}
          </Collapse>
        </div>
        <div>
          {loggedIn && <Modal
            isOpen={this.state.logOutModal}
            toggle={() => this.toggleModal("logOutModal")}
            className="modal-dialog-centered modal-danger"
            contentClassName="bg-gradient-livenyte "
            fade={false}
            size="sm"
          >
            <div className="modal-header">
              <h6
                className="modal-title"
                id="modal-title-notification"
              >
                {/* Log Out */}
              </h6>
              <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() =>
                  this.toggleModal("logOutModal")
                }
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="py-3 text-center">
                <img
                  style={{ height: "100px", width: "100px", borderRadius: "50%", objectFit: "cover" }}
                  src={(loggedIn && info && info.image) ? info.image : logo}
                  onError={(e) => { e.target.onerror = null; e.target.src = defaultAvatar }}
                  alt="Avatar" />
                <h4 className="heading mt-4">
                </h4>
                <p>
                  {!userIsAgencyAsClient &&
                    <span>Are you sure you want to log out?</span>}
                  {userIsAgencyAsClient &&
                    <span>Are you sure you want to change clients?</span>}
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <Button
                className="text-white "
                color="link"
                data-dismiss="modal"
                type="button"
                onClick={() =>
                  this.toggleModal("logOutModal")
                }
              >
                Back
              </Button>
              <Button
                className="ml-auto"
                color="spc-white"
                outline
                type="button"
                onClick={() => this.signOut()}

              >
                {!userIsAgencyAsClient &&
                  <span>Logout</span>}
                {userIsAgencyAsClient &&
                  <span>Change Client</span>}
              </Button>
            </div>
          </Modal>}
        </div>

      </div>
    );
    return (
      <>
        {this.state.alert}
        <Navbar
          className={"sidenav navbar-vertical fixed-left navbar-expand-xs bg-sidebar " + (prefersDark ? "navbar-dark " : "navbar-light")}
          onMouseEnter={this.onMouseEnterSidenav}
          onMouseLeave={this.onMouseLeaveSidenav}
        >
          {navigator.platform.indexOf("Win") > -1 ? (
            <PerfectScrollbar>{scrollBarInner}</PerfectScrollbar>
          ) : (
            scrollBarInner
          )}
        </Navbar>
      </>

    );
  }
}

Sidebar.defaultProps = {
  routes: [{}],
  toggleSidenav: () => { },
  sidenavOpen: false
};

Sidebar.propTypes = {
  // function used to make sidenav mini or normal
  toggleSidenav: PropTypes.func,
  // prop to know if the sidenav is mini or normal
  sidenavOpen: PropTypes.bool,
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  // logo
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,

    imgSrcDark: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired
  })
};

function mapStateToProps(state) {
  const { memberInfo, authentication, fanModeData } = state;
  const { loggedIn } = authentication;
  const { fetchingInfo, info, fetchingUserInfo, userInfo, } = memberInfo;
  const { fanMode } = fanModeData;

  return {
    fetchingInfo, info,
    fetchingUserInfo, userInfo,
    loggedIn,
    fanMode

  };
}

const connectedSidebar = connect(mapStateToProps)(Sidebar);
export { connectedSidebar as Sidebar };
